import { useLocation } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export const useEventScope = () => {
  const { pathname } = useLocation();
  return { isEventScope: pathname.includes('events') };
};
